module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-120x120-4544f582ad8b6f871435d92234422fde.png";